import { render, staticRenderFns } from "./Drag.vue?vue&type=template&id=46e304ef&"
import script from "./Drag.vue?vue&type=script&lang=js&"
export * from "./Drag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports